import { Component, Vue, Prop } from 'vue-property-decorator';


@Component
export default class Timer extends Vue {

  @Prop({default: '202207122359'}) EXPIRED_DATE: string;
  
  showTimer: boolean = true;
  
  timeend: any= '';
  timeOutOffer: any = ''

  days: string = '';
  seconds: string | number = '';
  minutes: string | number = '';
  hours: string | number = '';

  timeOutOfferChange()
  {
      var today : any= new Date();
      today = Math.floor((this.timeend-today)/1000);
      var tsec: string | number =today%60; today=Math.floor(today/60); if(tsec<0)tsec='00'; else if(tsec<10) tsec='0'+tsec;
      var tmin: string | number  =today%60; today=Math.floor(today/60); if(tmin<0)tmin='00'; else if(tmin<10) tmin='0'+tmin;
      var thour: string | number  =today%24; today=Math.floor(today/24);if(thour<0)thour='00'; if(today<0) today='00';
    

    this.days = today;
    this.seconds = tsec;
    this.minutes = tmin;
    this.hours = thour;


  }


  created(){

        var offerExpireDate = this.EXPIRED_DATE;

        this.timeend = new Date(Number(offerExpireDate.slice(0, 4)),
         Number(offerExpireDate.slice(4, 6)) - 1,
         Number(offerExpireDate.slice(6, 8)),
         Number(offerExpireDate.slice(8, 10)),
         Number(offerExpireDate.slice(10, 12)));
    
    if (this.timeend <= new Date()) {

      this.showTimer = false;
    }

    this.timeOutOffer = setInterval(this.timeOutOfferChange, 1000);
  }

}